import { render, staticRenderFns } from "./IconDotsVerticalSolid.vue?vue&type=template&id=5c6d344c"
import script from "./IconDotsVerticalSolid.vue?vue&type=script&lang=js"
export * from "./IconDotsVerticalSolid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports